<template>
  <div class="enterprise-info">
    <div class="tab-content">
      <div
        v-for="(item, index) of tabsList"
        :key="index"
        class="tab-btn"
        :class="{ active: currentIndex === index }"
        @click="handleTopTab(index, item)"
      >
        <span style="padding-right: 8px">{{ item.label }}</span>
      </div>
    </div>
    <el-form ref="formDom" :rules="rules" :model="formData" class="form-content" size="small">
      <div style="overflow: hidden; width: 100%">
        <TableList
          index-show
          :table-data="tabsList[currentIndex].tableData"
          :table-label="tableLabel"
          :highlight-current-row="false"
        >
          <template #certificateName="{ scope }">
            <el-form-item v-if="!isView">
              <el-tooltip
                :content="scope.row.certificateName"
                placement="top-start"
                :disabled="scope.row.certificateName.length <= 10"
              >
                <el-input
                  v-model.trim="scope.row.certificateName"
                  maxlength="50"
                  show-word-limit
                  size="small"
                  placeholder="证书名称"
                ></el-input>
              </el-tooltip>
            </el-form-item>
            <span v-else>
              {{ scope.row.certificateName }}
            </span>
          </template>
          <template #certificateNumber="{ scope }">
            <el-form-item v-if="!isView">
              <el-tooltip
                :content="scope.row.certificateNumber"
                placement="top-start"
                :disabled="scope.row.certificateNumber.length <= 10"
              >
                <el-input
                  v-model.trim="scope.row.certificateNumber"
                  maxlength="50"
                  show-word-limit
                  size="small"
                  placeholder="证书编号"
                ></el-input>
              </el-tooltip>
            </el-form-item>
            <span v-else>
              {{ scope.row.certificateNumber }}
            </span>
          </template>
          <template #limit="{ scope: { row } }">
            <el-form-item v-if="!isView">
              <el-radio-group v-model="row.limit">
                <el-radio :label="1">长期有效</el-radio>
                <el-radio :label="2">固定日期</el-radio>
              </el-radio-group>
              <!--  -->
              <el-date-picker
                v-model="row.time"
                style="margin-left: 20px"
                :disabled="row.limit === 1 || row.limit === ''"
                type="daterange"
                value-format="yyyy-MM-dd"
                range-separator="至"
                start-placeholder="开始日期"
                end-placeholder="结束日期"
              ></el-date-picker>
            </el-form-item>
            <span v-else>{{ getDate(row) }}</span>
          </template>
          <template #certificate="{ scope }">
            <eui-btn v-if="scope.row.certificateImg.url && status !== 1" color="#333" type="text">
              {{ shortenFileName(scope.row.certificateImg.fileName, 12, 3) }}
              <span @click="deleteImg(scope.$index)">
                <eui-icon icon="eicon-r-l-guanbi" color="#333" font-size="16px"></eui-icon>
              </span>
            </eui-btn>

            <template v-if="scope.row.certificateImg.url && status === 1 && isView">
              <el-image
                ref="cFImg"
                :src="bigImageUrl"
                :preview-src-list="previewSrcList"
                style="width: 0; height: 0"
              ></el-image>
              <eui-link type="link" font-size="12" color="#0064c8" @click="imageView(scope.row)">
                {{ shortenFileName(scope.row.certificateImg.fileName, 12, 3) }}
              </eui-link>
            </template>
            <!-- <div v-if="!scope.row.certificateImg.url && !isView" style="display: flex; justify-content: center">
              <eui-upload
                ref="euiUploadSix"
                class="store-single"
                :file-list="fileList"
                :action="certificateUpload"
                :headers="headers"
                accept=".png,.jpg,.jpeg,.pdf"
                :limit="1"
                text="上传附件"
                @handleSuccess="
                  (file) => {
                    videoSuccess(file, scope.$index);
                  }
                "
              ></eui-upload>
            </div> -->
          </template>
          <template #operate="{ scope }">
            <!-- <eui-btn v-if="scope.row.certificateImg.url" color="#333" type="text">
              {{ shortenFileName(scope.row.certificateImg.fileName, 12, 3) }}
              <span @click="deleteImg(scope.$index)">
                <eui-icon icon="eicon-r-l-guanbi" color="#333" font-size="16px"></eui-icon>
              </span>
            </eui-btn> -->

            <!-- <eui-btn
              v-if="!scope.row.certificateImg.url"
              type="link"
              @click="!scope.row.certificateImg.url && uploadOpen(scope.$index)"
            >
              上传附件
            </eui-btn> -->
            <div style="display: flex; justify-content: center">
              <eui-upload
                v-if="!scope.row.certificateImg.url && !isView"
                ref="euiUploadSix"
                list-type="link"
                class="store-single"
                :file-list="fileList"
                :action="certificateUpload"
                :headers="headers"
                accept=".png,.jpg,.jpeg,.pdf"
                :limitFileSize="limitFileSize"
                :limit="1"
                text="上传附件"
                @handleSuccess="
                  (file) => {
                    videoSuccess(file, scope.$index);
                  }
                "
              ></eui-upload>
              <eui-link style="margin-left: 10px" lighten @click="handleDelete(scope.$index)">删除</eui-link>
            </div>
          </template>
        </TableList>
        <div v-if="!isView" class="btn-wrapper">
          <div class="add-btn" @click="addTableData">
            <eui-icon icon="eicon-jichugongneng" color="#333" font-size="16"></eui-icon>
            <!-- <eui-icon icon="eicon-fwbb" color="#333" font-size="18px" /> -->
            <span>添加一行</span>
          </div>
        </div>
      </div>
    </el-form>
    <EDialog
      :append-to-body="true"
      dialog-title="上传附件"
      :center-dialog-visible.sync="visible"
      @resetPopupData="cancel"
      @submitPopupData="submit"
    >
      <eui-upload
        ref="euiUploadSix"
        class="store-single"
        :file-list="fileList"
        :action="certificateUpload"
        :headers="headers"
        accept=".png,.jpg,.jpeg,.pdf"
        show-file-list
        :limit="1"
        text="上传附件"
        @handleSuccess="videoSuccess"
      ></eui-upload>
    </EDialog>
  </div>
</template>

<script>
import TableList from '@/modules/projectA/components/common/e-table-list.vue';
import EDialog from '@/modules/projectA/components/common/e-dialog.vue';

import { certificateUpload, headers } from '../mixins';

export default {
  components: { TableList, EDialog },
  props: {
    tabs: {
      type: Array,
      default() {
        return [
          {
            label: '经营资质',
            value: 0,
            tableData: [
              {
                certificateName: '',
                certificateNumber: '',
                limit: '',
                time: [],
                certificateImg: [{ fileName: '', url: '' }],
              },
            ],
          },
          {
            label: '许可资质',
            value: 1,
            tableData: [
              {
                certificateName: '',
                certificateNumber: '',
                limit: '',
                time: [],
                certificateImg: [{ fileName: '', url: '' }],
              },
            ],
          },
          {
            label: '能力资质',
            value: 2,
            tableData: [
              {
                certificateName: '',
                certificateNumber: '',
                limit: '',
                time: [],
                certificateImg: [{ fileName: '', url: '' }],
              },
            ],
          },
          {
            label: '其他相关资质',
            value: 3,
            tableData: [
              {
                certificateName: '',
                certificateNumber: '',
                limit: '',
                time: [],
                certificateImg: [{ fileName: '', url: '' }],
              },
            ],
          },
        ];
      },
    },
    // 1-审核中 2-审核通过 3-审核拒绝
    status: {
      type: Number,
      default: 0,
    },
    isView: Boolean,
  },
  data() {
    return {
      certificateUpload,
      headers,
      visible: false,
      fileList: [],
      limitFileSize:20,
      tableIndex: 0,
      formData: {},
      rules: {
        productName: {
          type: 'string',
          required: true,
          message: '请输入商品名称',
          trigger: 'blur',
        },
        requiredQuantity: {
          required: true,
          validator: this.validateRequiredQuantity,
          trigger: 'blur',
        },
        quotationDeadline: [
          { required: true, message: '请选择报价截止日期', trigger: 'change' },
          {
            validator: (rule, value, callback) => {
              if (this.formData.releaseTime >= value) {
                callback(new Error('报价截止时间不得小于报价开始时间'));
              } else if (new Date().getTime() >= value) {
                callback(new Error('报价截止时间不得小于当前时间'));
              } else {
                callback();
              }
            },
            message: '',
            trigger: 'change',
          },
        ],
        releaseTime: [{ required: true, message: '请选择报价开始时间', trigger: 'change' }],
      },

      tabsList: [],

      currentIndex: 0,

      tableLabel: [
        {
          label: '证书名称',
          param: 'skuCode',
          align: 'center',
          width: '220',
          slot: 'certificateName',
        },
        {
          label: '证书编号',
          param: 'skuCode',
          align: 'center',
          width: '220',
          slot: 'certificateNumber',
        },
        {
          label: '有效期结束时间',
          param: 'skuCode',
          align: 'center',
          width: '600',
          slot: 'limit',
        },
        {
          label: '证书',
          align: 'center',
          minWidth: '180',
          slot: 'certificate',
        },
        {
          label: '操作',
          align: 'center',
          width: '140',
          slot: 'operate',
        },
      ],

      currentFile: {},

      bigImageUrl: '',
      previewSrcList: [],
    };
  },
  computed: {},
  watch: {
    tabs: {
      handler(val) {
        if (val.length) {
          this.tabsList = JSON.parse(JSON.stringify(this.tabs));
        }
      },
      deep: true,
    },
    isView: {
      handler(newVal) {
        if (newVal) {
          this.tableLabel.pop();
        }
      },
      immediate: true,
    },
  },
  created() {
    this.tabsList = this.tabs;
  },
  methods: {
    shortenFileName(filename, maxLength, minSuffixLength) {
      const parts = filename.split('.');
      const ext = parts.pop();
      const baseName = parts.join('');

      if (baseName.length + ext.length + 3 <= maxLength) {
        return filename;
      }

      const totalAvailableForBaseName = maxLength - ext.length - 3;
      const minBaseNameLength = minSuffixLength + (minSuffixLength > 0 ? 3 : 0); // 如果有最小后缀长度要求，则加上省略号的长度
      const maxBaseNameLength = totalAvailableForBaseName - minBaseNameLength;

      let startPartLength = Math.floor((maxBaseNameLength - minSuffixLength) / 2);
      let endPartLength = maxBaseNameLength - startPartLength;

      // 确保开始部分和结束部分都有至少一个字符
      if (startPartLength <= 0) {
        startPartLength = 1;
        endPartLength -= 1;
      }

      const startPart = baseName.slice(0, startPartLength);
      const endPart = baseName.slice(-endPartLength);

      return `${startPart}...${endPart}.${ext}`;
    },

    deleteImg(index) {
      console.log(index);
      setTimeout(() => {
        this.tabsList[this.currentIndex].tableData[index].certificateImg = [{ fileName: '', url: '' }];
        this.fileList = [];
      }, 100);
    },

    handleDelete(index) {
      this.tabsList[this.currentIndex].tableData.splice(index, 1);
    },
    handleTopTab(index) {
      this.currentIndex = index;
      this.$emit('getIndex', index);
    },
    uploadOpen(index) {
      this.visible = true;
      this.tableIndex = index;
    },
    // 添加
    addTableData() {
      if (this.tabsList[this.currentIndex].tableData.length > 49) {
        this.$message.warning('每个资质最多可添加50条');
        return;
      }
      const item = {
        certificateName: '',
        certificateNumber: '',
        limit: '',
        time: [],
        certificateImg: [{ fileName: '', url: '' }],
      };

      this.tabsList[this.currentIndex].tableData.push(item);
    },

    cancel() {
      this.visible = false;
      this.fileList = [];
      this.tableIndex = 0;
      this.currentFile = {};
    },
    submit() {
      this.tabsList[this.currentIndex].tableData[this.tableIndex].certificateImg = this.currentFile;
      this.cancel();
    },
    videoSuccess(file, index) {
      if (file.code === '200') {
        const { data } = file;
        this.currentFile = data;
        this.tabsList[this.currentIndex].tableData[index].certificateImg = this.currentFile;
        this.fileList = [];
        console.log(1);
      }
    },

    imageView(row) {
      console.log(row);
      const {
        certificateImg: { fileName, url },
      } = row;

      const { length } = fileName.split('.');
      if (fileName.split('.')[length - 1] === 'pdf') {
        window.open(url);
        return;
      }
      this.bigImageUrl = url;
      this.previewSrcList = [row.certificateImg.url];
      this.$nextTick(() => {
        this.$refs.cFImg.showViewer = true;
      });
    },
    getDate(row) {
      if (row.limit === 1) {
        return '长期有效';
      }
      if (row.limit === '') {
        return '';
      }
      return row.time.join('至');
    },
  },
};
</script>
<style lang="scss" scoped>
.enterprise-info {
  ::v-deep .el-form {
    .el-table__empty-block {
      min-height: 50px;
      height: 50px;
    }
    .el-table__empty-text {
      line-height: 50px;
    }
  }
  ::v-deep .el-form-item--small.el-form-item {
    margin-bottom: 0;
  }
}
.tab-content {
  display: flex;
  align-items: center;
  position: relative;
  .tab-btn {
    position: relative;
    height: 40px;
    line-height: 40px;
    width: 160px;
    white-space: nowrap;
    cursor: pointer;
    background: #fff;
    color: #606266;
    text-align: center;
    box-sizing: border-box;
    outline: 0;
    margin: 0;
    font-weight: 500;
    padding: 0 20px;
    font-size: 14px;
    border-left: 1px solid #d9d9d9;
    border-bottom: 1px solid #d9d9d9;
    border-top: 1px solid #d9d9d9;
    &:last-child {
      border-right: 1px solid #d9d9d9;
    }
    &:first-child {
      border-left: 0;
    }
    &.active {
      background: #f4f7ff;
      color: #0064c8;
      height: 40px;
      line-height: 40px;
      &::after {
        position: absolute;
        left: 0;
        right: 0;
        top: -1px;
        content: '';
        width: 100%;
        height: 2px;
        background: #0064c8;
      }
    }
  }
}
.btn-wrapper {
  padding: 10px;
  background: #f5f5f5;
  .add-btn {
    height: 40px;
    display: flex;
    justify-content: center;
    align-items: center;
    cursor: pointer;
    font-size: 16px;
    border: 1px solid #c5c5c5;
    background: #fff;
    span {
      margin-left: 6px;
    }
  }
}
</style>
